import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HormonalImbalancePage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Hormonal Imbalance</h1>
        <section className="mb-8">
          <p>Hormonal imbalances can affect various aspects of health, including mood, metabolism, and reproductive function. Our natural therapies focus on restoring hormonal balance, supporting glandular health, and promoting overall well-being through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Stress</li>
            <li>Poor diet</li>
            <li>Thyroid dysfunction</li>
            <li>Polycystic ovarian disease (PCOD)</li>
            <li>Menopause or andropause</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Irregular periods</li>
            <li>Weight changes</li>
            <li>Mood swings</li>
            <li>Fatigue</li>
            <li>Sleep disturbances</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use hormone-balancing herbs, adaptogens, and lifestyle modifications to naturally treat hormonal imbalances. Our approach focuses on restoring balance, supporting glandular health, and promoting overall well-being through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural hormone balance</li>
            <li>Improved mood and energy</li>
            <li>No harsh side effects</li>
            <li>Long-term well-being</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a balanced diet</li>
            <li>Exercise regularly</li>
            <li>Manage stress</li>
            <li>Get adequate sleep</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 1-3 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for all ages?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all age groups.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment help with fertility?</strong>
            <p>A: Yes, our holistic approach supports reproductive health and fertility.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from hormonal imbalance—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default HormonalImbalancePage; 